import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

export interface Database {
  public: {
    Tables: {
      messages: {
        Row: {
          id: string;
          content: string;
          sender_id: string;
          receiver_id: string;
          created_at: string;
          read: boolean;
          is_admin_message: boolean;
        };
        Insert: {
          content: string;
          sender_id: string;
          receiver_id: string;
          read?: boolean;
          is_admin_message?: boolean;
        };
      };
      user_status: {
        Row: {
          user_id: string;
          is_online: boolean;
          last_seen: string;
          is_typing: boolean;
          typing_to_user_id?: string;
        };
        Insert: {
          user_id: string;
          is_online?: boolean;
          last_seen?: string;
          is_typing?: boolean;
          typing_to_user_id?: string;
        };
      };
    };
  };
}

// Export the URL and key for admin operations
export const supabaseConfig = {
  url: supabaseUrl,
  key: supabaseAnonKey
};

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});

// Add these getters
Object.defineProperty(supabase, 'supabaseUrl', {
  get: () => supabaseUrl
});

Object.defineProperty(supabase, 'supabaseKey', {
  get: () => supabaseAnonKey
});

// Verify connection
supabase.auth.onAuthStateChange((event, session) => {
  console.log('Supabase auth event:', event);
  if (event === 'SIGNED_IN') {
    console.log('User signed in:', session?.user?.email);
  }
});